<template>
    <div class="coupon">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :immediate-check="false"
                @load="getCouponList"
                class="content-collect"
        >
        <div class="coupon-li" v-for="(item,index) in list" :key="index">
            <div class="train-title" style="padding: 12px 12px 0 12px">
                <img :src="util.G_CONFIG.logo" v-if="util.G_CONFIG.logo != ''" style="width: 18px;vertical-align: middle;margin-right: 5px">
                <span v-if="util.G_CONFIG.train_name != ''" style="font-size: 12px;color: #999">{{util.G_CONFIG.train_name}}</span>
            </div>
            <div class="coupon-content">
                <div class="coupon-type">
                    <span v-if="item.coupon_type == 1">抵扣券</span>
                    <span v-if="item.coupon_type == 2">折扣券</span>
                </div>
                <div class="coupon-money">
                    <span>{{item.coupon_name}}</span>

                    <div style="color: #327CE9;float: right">
                        <span v-if="item.coupon_type == 1"><span class="coupon-money-txt">{{item.money * 1 }}</span>元</span>
                        <span v-if="item.coupon_type == 2"><span class="coupon-money-txt">{{item.discount * 1 }}</span>折</span>
                    </div>
                </div>
                <div class="coupon-txt">
                    <span v-if="item.coupon_type == 1 && item.full_money*1>0">
                        满{{item.full_money * 1 }}元减{{item.money * 1}}元
                    </span>
                    <span v-if="item.coupon_type == 2 && item.full_money*1>0">
                        满{{item.full_money * 1 }}元打{{item.discount * 1}}折
                    </span>
                    <span v-if="item.full_money*1 == 0">无门槛使用</span>
                </div>
            </div>
            <div class="coupon-btn">
                <div class="coupon-time">
                    <span>
                        此券有效期至{{item.use_time_end_date}}
                    </span>
                </div>
                <div class="coupon-receive-btn">
                    <div class="coupon-receive color-FF5C4A" @click="bindReceiveCoupon(item.coupon_id,index)">
                        <span>{{(item.receive*1) == 0?'立即':'继续'}}领取</span>
                    </div>
                    <div class="coupon-receive color-327CE9" @click="bindGoCouponCourse(item.coupon_id)" v-if="(item.receive*1) > 0">
                        <span>立即使用</span>
                    </div>
                </div>
            </div>

            <div class="coupon-received" v-if="(item.receive*1) > 0">
                已领取
            </div>
        </div>
        </van-list>
    </div>
</template>

<script>
    import { List } from 'vant';
    export default {
        name: "index",
        components:{
            [List.name]:List
        },
        data(){
            return {
                list:[],
                total:0,
                page:1,
                pageSize:10,
                loading: false,
                finished: false,
            }
        },
        mounted() {
            this.getCouponList(1);
            this.bindWeiXin();
        },
        methods:{
            bindReceiveCoupon(coupon_id,index){
                var _self=this;

                this.util.server.mini_coupon.receive_coupon({
                    data:{
                        coupon_id:coupon_id
                    },
                    callback: (res => {
                        if(res.code == 1){
                            this.util.showToast({
                                message: res.msg
                            });

                            this.list[index].receive = this.list[index].receive*1+1;
                        }
                    })
                })
            },
            bindGoCouponCourse(coupon_id){
                this.$router.push(this.util.urlPrefix+'/coupon/coupon_course?coupon_id='+coupon_id+'&token='+this.util.token)
            },
            bindWeiXin(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    var _that=_self;
                    _self.util.wxShare(wx, {
                        title: _that.module_name,
                        desc: _that.module_name,
                        link: location.href,
                        imgUrl: this.util.G_CONFIG.logo
                    });
                });
            },
            getCouponList(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{

                    this.page=page;

                }
                this.util.server.mini_coupon.index_coupon({
                    data:{
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    methods:'get',
                    callback: (res => {
                        const { code, data, msg } = res;

                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                // for (var i = 0; i < data.items.length; i++) {
                                //     data.items[i]['link'] = this.util.getMiniCourseTypeUrl(data.items[i].type, data.items[i].course_id, data.items[i].p_course_id) + '&current=' + (data.items[i].sections_id || '');
                                // }

                                if(page == 1){
                                    this.list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;
                                //判断是否存在下一页
                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
        }
    }
</script>

<style scoped>
    .color-FF5C4A{
        color: #FF5C4A;
    }
    .color-327CE9{
        color: #327CE9;
    }
    div{
        color: #3a3a3a;
    }
    .coupon-received{
        position: absolute;
        left: 50%;
        top: 50%;
        color: #FF5C4A;
        font-size: 25px;
        transform: rotate(-28deg);
        opacity: .5;
        margin-left: -30px;
        margin-top: -17px;
    }
    .coupon-surplus{
        font-size: 12px;
        font-weight: 500;
        padding: 2px 5px;
        background-color: #ff847c;
        color: #fff;
        border-radius: 10px;
        margin-left: 5px;
    }
    .coupon-li{
        margin: 10px;
        position: relative;
        background-color: #fff;
        border-radius: 5px;
        overflow: hidden;
    }
    .coupon-content{
        padding: 10px 20px;
    }
    .coupon-type{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 10px;
        padding: 2px 5px;
        background-color: #FF5C4A;
        color: #fff;
        border-radius:4px 4px 4px 0;
    }
    .coupon-money{
        font-weight: bold;
        font-size: 16px;
    }
    .coupon-money-txt{
        font-size: 30px;
        color: #327CE9;
        margin-right: 2px;
    }
    .coupon-txt{
        font-size: 12px;
        margin-top: 5px;
        color: #999;
    }
    .coupon-btn{
        position: relative;
        padding: 25px 20px;
        padding-right: 80px;
        background-image: linear-gradient(to right, #eee 0%, #eee 50%, transparent 50%);
        background-size: 28px 1px;
        background-repeat: repeat-x;
    }
    .coupon-btn::after,.coupon-btn::before{
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background-color: #f8f8f8;
        border-radius: 10px;
    }
    .coupon-btn::after{
        top: -10px;
        right: -10px;
    }
    .coupon-btn::before{
        top: -10px;
        left: -10px;
    }
    .coupon-time{
        display: inline-block;
        font-size: 12px;
        color: #999999;
    }
    .coupon-receive{
        font-size: 12px;
    }
    .coupon-receive-btn{
        position: absolute;
        right: 10px;
        top: 0;
        width: 58px;
        height: 100%;
        /*flex 布局*/
        display: flex;
        flex-wrap: wrap;
        /*实现垂直居中*/
        align-items: center;
        /*实现水平居中*/
        justify-content: center;
    }
</style>
